import { render, staticRenderFns } from "./AvisosBanner.vue?vue&type=template&id=ca754d38&scoped=true&"
import script from "./AvisosBanner.vue?vue&type=script&lang=js&"
export * from "./AvisosBanner.vue?vue&type=script&lang=js&"
import style0 from "./AvisosBanner.vue?vue&type=style&index=0&id=ca754d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca754d38",
  null
  
)

export default component.exports